import { LayoutDashboard, Inbox, Mail, CalendarDays, Sparkles, Ticket, DoorOpen, FileText, Image, Users, Plug, Settings, Newspaper, BarChart3, Send, MessageSquareText } from "lucide-react";

/** Grouped information architecture for the admin portal (design_guidelines.md → admin_portal.navigation_groups). */
export const NAV_GROUPS = [
  { label: null, items: [{ to: "/admin", label: "Oversikt", icon: LayoutDashboard, id: "dashboard", end: true, description: "Det viktigaste no" }] },
  {
    label: "Drift",
    items: [
      { to: "/admin/bookingar", label: "Bookingar", icon: Inbox, id: "bookings", badge: "bookings", description: "Førespurnader om leige" },
      { to: "/admin/meldingar", label: "Meldingar", icon: Mail, id: "messages", badge: "messages", description: "Frå kontaktskjemaet" },
      { to: "/admin/kalender", label: "Kalender", icon: CalendarDays, id: "calendar", description: "Månad, veke, tidslinje og terminliste" },
    ],
  },
  {
    label: "Program",
    items: [
      { to: "/admin/arrangement", label: "Arrangement", icon: Sparkles, id: "events", description: "Program på nettsida" },
      { to: "/admin/billettar", label: "Billettar", icon: Ticket, id: "tickets", badge: "tickets", description: "Reservasjonar, arrangørar og oppgjer" },
      { to: "/admin/nytt", label: "Nyheiter", icon: Newspaper, id: "posts", description: "Nytt frå huset – skriv sjølv eller med AI" },
    ],
  },
  {
    label: "Innsikt",
    items: [
      { to: "/admin/statistikk", label: "Statistikk", icon: BarChart3, id: "stats", description: "Besøk, bookingar, billettar og folk" },
      { to: "/admin/nyheitsbrev", label: "Nyheitsbrev", icon: Send, id: "newsletter", description: "Abonnentar og eksport" },
    ],
  },
  {
    label: "Nettsida",
    items: [
      { to: "/admin/rom", label: "Rom og prisar", icon: DoorOpen, id: "rooms", description: "Beskriving, kapasitet og prisliste", adminOnly: true },
      { to: "/admin/innhald", label: "Innhald", icon: FileText, id: "content", description: "Tekstar og bilete på sidene", adminOnly: true },
      { to: "/admin/bilete", label: "Bilete", icon: Image, id: "images", description: "Biletebibliotek" },
      { to: "/admin/bildekommentarar", label: "Bildekommentarar", icon: MessageSquareText, id: "photocomments", badge: "photocomments", description: "Private merknader til bilete frå publikum", adminOnly: true },
      { to: "/admin/folk", label: "Styret og lag", icon: Users, id: "people", description: "Styremedlemer og faste brukarar", adminOnly: true },
    ],
  },
  {
    label: "System",
    footer: true,
    items: [
      { to: "/admin/integrasjonar", label: "Integrasjonar", icon: Plug, id: "integrations", description: "E-post og SMS", adminOnly: true },
      { to: "/admin/innstillingar", label: "Innstillingar", icon: Settings, id: "settings", description: "Kontaktinfo, varsling, brukarar, passord" },
    ],
  },
];

export const NAV_ITEMS = NAV_GROUPS.flatMap((g) => g.items);

/** Navigation visible to the signed-in role – «bruker» only sees the operational pages. */
export const navGroupsFor = (isAdmin) => (isAdmin ? NAV_GROUPS : NAV_GROUPS.map((g) => ({ ...g, items: g.items.filter((i) => !i.adminOnly) })).filter((g) => g.items.length));

export const ADMIN_ONLY_PATHS = NAV_ITEMS.filter((i) => i.adminOnly).map((i) => i.to);

/** Shortcuts surfaced in the topbar “Ny”-menu and the command palette. Pages read `?ny=1` and open their create-dialog. */
export const QUICK_ACTIONS = [
  { id: "new-entry", label: "Ny oppføring i kalenderen", to: "/admin/kalender?ny=1", icon: CalendarDays },
  { id: "new-event", label: "Nytt arrangement", to: "/admin/arrangement?ny=1", icon: Sparkles },
  { id: "new-organizer", label: "Ny arrangør", to: "/admin/billettar?fane=arrangorar&ny=1", icon: Users },
  { id: "upload-image", label: "Last opp bilete", to: "/admin/bilete", icon: Image },
];

export const isNavActive = (item, pathname) => (item.end ? pathname === item.to : pathname.startsWith(item.to));

export const currentNavItem = (pathname) => NAV_ITEMS.filter((i) => !i.end).find((i) => isNavActive(i, pathname)) || NAV_ITEMS.find((i) => i.end && isNavActive(i, pathname)) || null;
